<template>
    <div :id="rootElementId" class="d-flex justify-center w-100">
        <div class="d-flex" :style="{width:size+'px'}">
            <el-table :data="shotsGrouped" size="mini"
                :id="tableElementId"
                class="finishing-table"
                :cell-style="{padding: '0'}"
                :cell-class-name="`px-1 ${darkMode ? 'primary--text text-lighten-1' : ''}`">
                <el-table-column prop="seasonName" class-name="full-size-cell left" align="left">
                    <template slot="header" slot-scope="">
                        <div class="d-flex flex-column text-ellipsis">
                            <span v-if="playerSeasonData[0]" class="text-ellipsis">{{playerSeasonData[0].playerName}}</span>
                            <span class="body-2 text-ellipsis primary--text mt-n1">{{typeTitle}}</span>
                        </div>
                    </template>
                    <template slot-scope="item">
                        <div class="d-flex flex-column pl-2 pr-2 text-ellipsis">
                            <span class="body-2 primary--text text-ellipsis"
                            v-bind:class="{'font-weight-medium': item.row.seasonId,'font-weight-bold':!item.row.seasonId}">{{ item.row.seasonId ? formatLeagueLabelYear(item.row) : item.row.seasonName}}</span>
                            <div class="d-flex align-center body-2">
                                <span>{{item.row.shots.length}} {{$t("game.stats.shots")}}</span>
                                <div class="d-flex align-center text-ellipsis" v-if="item.row.seasonId">
                                    <span class="px-1"> - </span>
                                    <span class="text-ellipsis">{{item.row.teamName}}</span>
                                </div>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <!-- xG Section Start -->
                <el-table-column v-if="type === 'xg'" prop="xg1" label="0,00 - 0,05 xG" label-class-name="primary--text" class-name="full-size-cell">
                    <template slot-scope="item">
                        <div class="w-100 h-100 d-flex align-start justify-space-between pl-2 pr-2 py-1"
                            v-bind:style="{'background-color':getBackgroundColorBlue(item.row,'xg',['0','0.05'])}">
                            <div class="d-flex flex-column flex-grow-1 text-ellipsis">
                                <span class="body-2 primary--text font-weight-bold">
                                    {{((filterShots(item.row.shots,"xg","0","0.05").length / item.row.shots.length) * 100).toFixed(0).replace("NaN",0)}}%
                                </span>
                                <div class="d-flex align-center text-ellipsis">
                                    <span class="body-2 text-ellipsis primary--text">{{filterShots(item.row.shots,"xg","0","0.05").length}} {{$t("game.stats.shots")}}</span>
                                </div>
                            </div>
                            <div class="d-flex flex-column align-center">
                                <v-badge inline color="black" text-color="white" :content="filterShots(item.row.shots,'xg','0','0.05',true).length || '0'" class="font-weight-bold"></v-badge>
                                <span class="black--text mt-n1" style="font-size:10px;">{{$t("playerRecruitment.radarDescription.basicStatistics.goals")}}</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column v-if="type === 'xg'" prop="xg2" label="0,05 - 0,10 xG" label-class-name="primary--text" class-name="full-size-cell">
                    <template slot-scope="item">
                        <div class="w-100 h-100 d-flex align-start justify-space-between pl-2 pr-2 py-1"
                            v-bind:style="{'background-color':getBackgroundColorBlue(item.row,'xg',['0.05','0.1'])}">
                            <div class="d-flex flex-column flex-grow-1 text-ellipsis">
                                <span class="body-2 primary--text font-weight-bold">
                                    {{((filterShots(item.row.shots,"xg","0.05","0.1").length / item.row.shots.length) * 100).toFixed(0).replace("NaN",0)}}%
                                </span>
                                <div class="d-flex align-center text-ellipsis">
                                    <span class="body-2 text-ellipsis primary--text">{{filterShots(item.row.shots,"xg","0.05","0.1").length}} {{$t("game.stats.shots")}}</span>
                                </div>
                            </div>
                            <div class="d-flex flex-column align-center">
                                <v-badge inline color="black" text-color="white" :content="filterShots(item.row.shots,'xg','0.05','0.1',true).length || '0'" class="font-weight-bold"></v-badge>
                                <span class="black--text mt-n1" style="font-size:10px;">{{$t("playerRecruitment.radarDescription.basicStatistics.goals")}}</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column v-if="type === 'xg'" prop="xg3" label="0,10 - 0,30 xG" label-class-name="primary--text" class-name="full-size-cell">
                    <template slot-scope="item">
                        <div class="w-100 h-100 d-flex align-start justify-space-between pl-2 pr-2 py-1"
                            v-bind:style="{'background-color':getBackgroundColorBlue(item.row,'xg',['0.1','0.3'])}">
                            <div class="d-flex flex-column flex-grow-1 text-ellipsis">
                                <span class="body-2 primary--text font-weight-bold">
                                    {{((filterShots(item.row.shots,"xg","0.1","0.3").length / item.row.shots.length) * 100).toFixed(0).replace("NaN",0)}}%
                                </span>
                                <div class="d-flex align-center text-ellipsis">
                                    <span class="body-2 text-ellipsis primary--text">{{filterShots(item.row.shots,"xg","0.1","0.3").length}} {{$t("game.stats.shots")}}</span>
                                </div>
                            </div>
                            <div class="d-flex flex-column align-center">
                                <v-badge inline color="black" text-color="white" :content="filterShots(item.row.shots,'xg','0.1','0.3',true).length || '0'" class="font-weight-bold"></v-badge>
                                <span class="black--text mt-n1" style="font-size:10px;">{{$t("playerRecruitment.radarDescription.basicStatistics.goals")}}</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column v-if="type === 'xg'" prop="xg4" label="0,30 - 1 xG" label-class-name="primary--text" class-name="full-size-cell">
                    <template slot-scope="item">
                        <div class="w-100 h-100 d-flex align-start justify-space-between pl-2 pr-2 py-1"
                            v-bind:style="{'background-color':getBackgroundColorBlue(item.row,'xg',['0.3','1'])}">
                            <div class="d-flex flex-column flex-grow-1 text-ellipsis">
                                <span class="body-2 primary--text font-weight-bold">
                                    {{((filterShots(item.row.shots,"xg","0.3","1").length / item.row.shots.length) * 100).toFixed(0).replace("NaN",0)}}%
                                </span>
                                <div class="d-flex align-center text-ellipsis">
                                    <span class="body-2 text-ellipsis primary--text">{{filterShots(item.row.shots,"xg","0.3","1").length}} {{$t("game.stats.shots")}}</span>
                                </div>
                            </div>
                            <div class="d-flex flex-column align-center">
                                <v-badge inline color="black" text-color="white" :content="filterShots(item.row.shots,'xg','0.3','1',true).length || '0'" class="font-weight-bold"></v-badge>
                                <span class="black--text mt-n1" style="font-size:10px;">{{$t("playerRecruitment.radarDescription.basicStatistics.goals")}}</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <!-- xG Section End -->

                <!-- TypeShot Section Start -->
                <el-table-column :label="$t('finishingMap.onGoal')" align="center" class-name="category-header text-ellipsis"
                    v-if="type === 'typeShot'">
                        <el-table-column prop="typeShot1" :label="$t('finishingMap.goal')" label-class-name="primary--text text-ellipsis" class-name="full-size-cell">
                            <template slot-scope="item">
                                <div class="w-100 h-100 d-flex align-start justify-space-between pl-2 pr-2 py-1"
                                    v-bind:style="{'background-color':getBackgroundColorBlue(item.row,'typeShot',['GOAL',''])}">
                                    <div class="d-flex flex-column flex-grow-1 text-ellipsis">
                                        <span class="body-2 primary--text font-weight-bold">
                                            {{((filterShots(item.row.shots,'typeShot','GOAL','').length / item.row.shots.length) * 100).toFixed(0).replace("NaN",0)}}%
                                        </span>
                                        <div class="d-flex align-center text-ellipsis">
                                            <span class="body-2 text-ellipsis primary--text">{{filterShots(item.row.shots,'typeShot','GOAL','').length}} {{$t("game.stats.shots")}}</span>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="typeShot2" :label="$t('finishingMap.savedShot')" label-class-name="primary--text text-ellipsis" class-name="full-size-cell">
                            <template slot-scope="item">
                                <div class="w-100 h-100 d-flex align-start justify-space-between pl-2 pr-2 py-1"
                                    v-bind:style="{'background-color':getBackgroundColorBlue(item.row,'typeShot',['SAVED SHOT',''])}">
                                    <div class="d-flex flex-column flex-grow-1 text-ellipsis">
                                        <span class="body-2 primary--text font-weight-bold">
                                            {{((filterShots(item.row.shots,'typeShot','SAVED SHOT','').length / item.row.shots.length) * 100).toFixed(0).replace("NaN",0)}}%
                                        </span>
                                        <div class="d-flex align-center text-ellipsis">
                                            <span class="body-2 text-ellipsis primary--text">{{filterShots(item.row.shots,'typeShot','SAVED SHOT','').length}} {{$t("game.stats.shots")}}</span>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                </el-table-column>
                <el-table-column :label="$t('finishingMap.outOfGoal')" align="center" class-name="category-header text-ellipsis"
                    v-if="type === 'typeShot'">
                        <el-table-column prop="typeShot3" :label="$t('finishingMap.missedShot')" label-class-name="primary--text text-ellipsis" class-name="full-size-cell">
                            <template slot-scope="item">
                                <div class="w-100 h-100 d-flex align-start justify-space-between pl-2 pr-2 py-1"
                                    v-bind:style="{'background-color':getBackgroundColorBlue(item.row,'typeShot',['MISSED SHOT',''])}">
                                    <div class="d-flex flex-column flex-grow-1 text-ellipsis">
                                        <span class="body-2 primary--text font-weight-bold">
                                            {{((filterShots(item.row.shots,'typeShot','MISSED SHOT','').length / item.row.shots.length) * 100).toFixed(0).replace("NaN",0)}}%
                                        </span>
                                        <div class="d-flex align-center text-ellipsis">
                                            <span class="body-2 text-ellipsis primary--text">{{filterShots(item.row.shots,'typeShot','MISSED SHOT','').length}} {{$t("game.stats.shots")}}</span>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="typeShot4" :label="$t('finishingMap.shotOnPost')" label-class-name="primary--text text-ellipsis" class-name="full-size-cell">
                            <template slot-scope="item">
                                <div class="w-100 h-100 d-flex align-start justify-space-between pl-2 pr-2 py-1"
                                    v-bind:style="{'background-color':getBackgroundColorBlue(item.row,'typeShot',['SHOT ON POST',''])}">
                                    <div class="d-flex flex-column flex-grow-1 text-ellipsis">
                                        <span class="body-2 primary--text font-weight-bold">
                                            {{((filterShots(item.row.shots,'typeShot','SHOT ON POST','').length / item.row.shots.length) * 100).toFixed(0).replace("NaN",0)}}%
                                        </span>
                                        <div class="d-flex align-center text-ellipsis">
                                            <span class="body-2 text-ellipsis primary--text">{{filterShots(item.row.shots,'typeShot','SHOT ON POST','').length}} {{$t("game.stats.shots")}}</span>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                </el-table-column>
                <!-- TypeShot Section End -->

                <!-- ShotStrategy Section Start -->
                <el-table-column :label="$t('finishingMap.openPlay')" align="center" class-name="category-header text-ellipsis"
                    v-if="type === 'shotStrategy'">
                        <el-table-column prop="shotStrategy1" :label="$t('finishingMap.regularPlay')" label-class-name="primary--text text-ellipsis" class-name="full-size-cell">
                            <template slot-scope="item">
                                <div class="w-100 h-100 d-flex align-start justify-space-between pl-2 pr-2 py-1"
                                    v-bind:style="{'background-color':getBackgroundColorBlue(item.row,'shotStrategy',['Regular play',''])}">
                                    <div class="d-flex flex-column flex-grow-1 text-ellipsis">
                                        <span class="body-2 primary--text font-weight-bold">
                                            {{((filterShots(item.row.shots,'shotStrategy','Regular play','').length / item.row.shots.length) * 100).toFixed(0).replace("NaN",0)}}%
                                        </span>
                                        <div class="d-flex align-center text-ellipsis">
                                            <span class="body-2 text-ellipsis primary--text">{{filterShots(item.row.shots,'shotStrategy','Regular play','').length}} {{$t("game.stats.shots")}}</span>
                                        </div>
                                    </div>
                                    <div class="d-flex flex-column align-center">
                                        <span class="black--text mt-n1" style="font-size:10px;">{{$t("playerRecruitment.radarDescription.basicStatistics.goals")}}</span>
                                        <v-badge inline color="black" text-color="white" :content="filterShots(item.row.shots,'shotStrategy','Regular play','',true).length || '0'" class="font-weight-bold"></v-badge>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="shotStrategy2" :label="$t('finishingMap.fastBreak')" label-class-name="primary--text text-ellipsis" class-name="full-size-cell">
                            <template slot-scope="item">
                                <div class="w-100 h-100 d-flex align-start justify-space-between pl-2 pr-2 py-1"
                                    v-bind:style="{'background-color':getBackgroundColorBlue(item.row,'shotStrategy',['Fast break',''])}">
                                    <div class="d-flex flex-column flex-grow-1 text-ellipsis">
                                        <span class="body-2 primary--text font-weight-bold">
                                            {{((filterShots(item.row.shots,'shotStrategy','Fast break','').length / item.row.shots.length) * 100).toFixed(0).replace("NaN",0)}}%
                                        </span>
                                        <div class="d-flex align-center text-ellipsis">
                                            <span class="body-2 text-ellipsis primary--text">{{filterShots(item.row.shots,'shotStrategy','Fast break','').length}} {{$t("game.stats.shots")}}</span>
                                        </div>
                                    </div>
                                    <div class="d-flex flex-column align-center">
                                        <v-badge inline color="black" text-color="white" :content="filterShots(item.row.shots,'shotStrategy','Fast break','',true).length || '0'" class="font-weight-bold"></v-badge>
                                        <span class="black--text mt-n1" style="font-size:10px;">{{$t("playerRecruitment.radarDescription.basicStatistics.goals")}}</span>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="shotStrategy3" :label="$t('finishingMap.individualPlay')" label-class-name="primary--text text-ellipsis" class-name="full-size-cell">
                            <template slot-scope="item">
                                <div class="w-100 h-100 d-flex align-start justify-space-between pl-2 pr-2 py-1"
                                    v-bind:style="{'background-color':getBackgroundColorBlue(item.row,'shotStrategy',['Individual play',''])}">
                                    <div class="d-flex flex-column flex-grow-1 text-ellipsis">
                                        <span class="body-2 primary--text font-weight-bold">
                                            {{((filterShots(item.row.shots,'shotStrategy','Individual play','').length / item.row.shots.length) * 100).toFixed(0).replace("NaN",0)}}%
                                        </span>
                                        <div class="d-flex align-center text-ellipsis">
                                            <span class="body-2 text-ellipsis primary--text">{{filterShots(item.row.shots,'shotStrategy','Individual play','').length}} {{$t("game.stats.shots")}}</span>
                                        </div>
                                    </div>
                                    <div class="d-flex flex-column align-center">
                                        <v-badge inline color="black" text-color="white" :content="filterShots(item.row.shots,'shotStrategy','Individual play','',true).length || '0'" class="font-weight-bold"></v-badge>
                                        <span class="black--text mt-n1" style="font-size:10px;">{{$t("playerRecruitment.radarDescription.basicStatistics.goals")}}</span>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                </el-table-column>
                <el-table-column :label="$t('finishingMap.setPiece')" align="center" class-name="category-header text-ellipsis"
                    v-if="type === 'shotStrategy'">
                    <el-table-column prop="shotStrategy4" :label="$t('finishingMap.freeKick')" label-class-name="primary--text text-ellipsis" class-name="full-size-cell">
                        <template slot-scope="item">
                            <div class="w-100 h-100 d-flex align-start justify-space-between pl-2 pr-2 py-1"
                                v-bind:style="{'background-color':getBackgroundColorBlue(item.row,'shotStrategy',['Free kick',''])}">
                                <div class="d-flex flex-column flex-grow-1 text-ellipsis">
                                    <span class="body-2 primary--text font-weight-bold">
                                        {{((filterShots(item.row.shots,'shotStrategy','Free kick','').length / item.row.shots.length) * 100).toFixed(0).replace("NaN",0)}}%
                                    </span>
                                    <div class="d-flex align-center text-ellipsis">
                                        <span class="body-2 text-ellipsis primary--text">{{filterShots(item.row.shots,'shotStrategy','Free kick','').length}} {{$t("game.stats.shots")}}</span>
                                    </div>
                                </div>
                                <div class="d-flex flex-column align-center">
                                    <v-badge inline color="black" text-color="white" :content="filterShots(item.row.shots,'shotStrategy','Free kick','',true).length || '0'" class="font-weight-bold"></v-badge>
                                    <span class="black--text mt-n1" style="font-size:10px;">{{$t("playerRecruitment.radarDescription.basicStatistics.goals")}}</span>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="shotStrategy5" :label="$t('finishingMap.indirectFreeKick')" label-class-name="primary--text text-ellipsis" class-name="full-size-cell">
                        <template slot-scope="item">
                            <div class="w-100 h-100 d-flex align-start justify-space-between pl-2 pr-2 py-1"
                                v-bind:style="{'background-color':getBackgroundColorBlue(item.row,'shotStrategy',['Indirect free kick',''])}">
                                <div class="d-flex flex-column flex-grow-1 text-ellipsis">
                                    <span class="body-2 primary--text font-weight-bold">
                                        {{((filterShots(item.row.shots,'shotStrategy','Indirect free kick','').length / item.row.shots.length) * 100).toFixed(0).replace("NaN",0)}}%
                                    </span>
                                    <div class="d-flex align-center text-ellipsis">
                                        <span class="body-2 text-ellipsis primary--text">{{filterShots(item.row.shots,'shotStrategy','Indirect free kick','').length}} {{$t("game.stats.shots")}}</span>
                                    </div>
                                </div>
                                <div class="d-flex flex-column align-center">
                                    <v-badge inline color="black" text-color="white" :content="filterShots(item.row.shots,'shotStrategy','Indirect free kick','',true).length || '0'" class="font-weight-bold"></v-badge>
                                    <span class="black--text mt-n1" style="font-size:10px;">{{$t("playerRecruitment.radarDescription.basicStatistics.goals")}}</span>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="shotStrategy6" :label="$t('finishingMap.fromCorner')" label-class-name="primary--text text-ellipsis" class-name="full-size-cell">
                        <template slot-scope="item">
                            <div class="w-100 h-100 d-flex align-start justify-space-between pl-2 pr-2 py-1"
                                v-bind:style="{'background-color':getBackgroundColorBlue(item.row,'shotStrategy',['From corner',''])}">
                                <div class="d-flex flex-column flex-grow-1 text-ellipsis">
                                    <span class="body-2 primary--text font-weight-bold">
                                        {{((filterShots(item.row.shots,'shotStrategy','From corner','').length / item.row.shots.length) * 100).toFixed(0).replace("NaN",0)}}%
                                    </span>
                                    <div class="d-flex align-center text-ellipsis">
                                        <span class="body-2 text-ellipsis primary--text">{{filterShots(item.row.shots,'shotStrategy','From corner','').length}} {{$t("game.stats.shots")}}</span>
                                    </div>
                                </div>
                                <div class="d-flex flex-column align-center">
                                    <v-badge inline color="black" text-color="white" :content="filterShots(item.row.shots,'shotStrategy','From corner','',true).length || '0'" class="font-weight-bold"></v-badge>
                                    <span class="black--text mt-n1" style="font-size:10px;">{{$t("playerRecruitment.radarDescription.basicStatistics.goals")}}</span>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="shotStrategy7" :label="$t('finishingMap.throwInSetPiece')" label-class-name="primary--text text-ellipsis" class-name="full-size-cell">
                        <template slot-scope="item">
                            <div class="w-100 h-100 d-flex align-start justify-space-between pl-2 pr-2 py-1"
                                v-bind:style="{'background-color':getBackgroundColorBlue(item.row,'shotStrategy',['Throw in set piece',''])}">
                                <div class="d-flex flex-column flex-grow-1 text-ellipsis">
                                    <span class="body-2 primary--text font-weight-bold">
                                        {{((filterShots(item.row.shots,'shotStrategy','Throw in set piece','').length / item.row.shots.length) * 100).toFixed(0).replace("NaN",0)}}%
                                    </span>
                                    <div class="d-flex align-center text-ellipsis">
                                        <span class="body-2 text-ellipsis primary--text">{{filterShots(item.row.shots,'shotStrategy','Throw in set piece','').length}} {{$t("game.stats.shots")}}</span>
                                    </div>
                                </div>
                                <div class="d-flex flex-column align-center">
                                    <v-badge inline color="black" text-color="white" :content="filterShots(item.row.shots,'shotStrategy','Throw in set piece','',true).length || '0'" class="font-weight-bold"></v-badge>
                                    <span class="black--text mt-n1" style="font-size:10px;">{{$t("playerRecruitment.radarDescription.basicStatistics.goals")}}</span>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <!-- ShotStrategy Section End -->

                <!-- Areas Section Start -->
                <el-table-column v-if="type === 'area'" prop="area1" :label="$t('finishingMap.goalArea')" label-class-name="primary--text" class-name="full-size-cell">
                    <template slot-scope="item">
                        <div class="w-100 h-100 d-flex align-start justify-space-between pl-2 pr-2 py-1"
                            v-bind:style="{'background-color':getBackgroundColorBlue(item.row,'area',[['goalArea'],''])}">
                            <div class="d-flex flex-column flex-grow-1 text-ellipsis">
                                <span class="body-2 primary--text font-weight-bold">
                                    {{((filterShots(item.row.shots,'area',['goalArea'],'').length / item.row.shots.length) * 100).toFixed(0).replace("NaN",0)}}%
                                </span>
                                <div class="d-flex align-center text-ellipsis">
                                    <span class="body-2 text-ellipsis primary--text">{{filterShots(item.row.shots,'area',['goalArea'],'').length}} {{$t("game.stats.shots")}}</span>
                                </div>
                            </div>
                            <div class="d-flex flex-column align-center">
                                <v-badge inline color="black" text-color="white" :content="filterShots(item.row.shots,'area',['goalArea'],'',true).length || '0'" class="font-weight-bold"></v-badge>
                                <span class="black--text mt-n1" style="font-size:10px;">{{$t("playerRecruitment.radarDescription.basicStatistics.goals")}}</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column v-if="type === 'area'" prop="area2" :label="$t('finishingMap.inBox')" label-class-name="primary--text" class-name="full-size-cell">
                    <template slot-scope="item">
                        <div class="w-100 h-100 d-flex align-start justify-space-between pl-2 pr-2 py-1"
                            v-bind:style="{'background-color':getBackgroundColorBlue(item.row,'area',[['boxRight','boxLeft','boxCenter'],''])}">
                            <div class="d-flex flex-column flex-grow-1 text-ellipsis">
                                <span class="body-2 primary--text font-weight-bold">
                                    {{((filterShots(item.row.shots,'area',['boxRight','boxLeft','boxCenter'],'').length / item.row.shots.length) * 100).toFixed(0).replace("NaN",0)}}%
                                </span>
                                <div class="d-flex align-center text-ellipsis">
                                    <span class="body-2 text-ellipsis primary--text">{{filterShots(item.row.shots,'area',['boxRight','boxLeft','boxCenter'],'').length}} {{$t("game.stats.shots")}}</span>
                                </div>
                            </div>
                            <div class="d-flex flex-column align-center">
                                <v-badge inline color="black" text-color="white" :content="filterShots(item.row.shots,'area',['boxRight','boxLeft','boxCenter'],'',true).length || '0'" class="font-weight-bold"></v-badge>
                                <span class="black--text mt-n1" style="font-size:10px;">{{$t("playerRecruitment.radarDescription.basicStatistics.goals")}}</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column v-if="type === 'area'" prop="area3" :label="$t('finishingMap.outOfBox')" label-class-name="primary--text" class-name="full-size-cell">
                    <template slot-scope="item">
                        <div class="w-100 h-100 d-flex align-start justify-space-between pl-2 pr-2 py-1"
                            v-bind:style="{'background-color':getBackgroundColorBlue(item.row,'area',[['outBoxDeepRight','outBoxDeepLeft','outBoxRight','outBoxCentreRight','outBoxCentre','outBoxCentreLeft','outBoxLeft','right35','centreRight35','centre35','centreLeft35','left35'],''])}">
                            <div class="d-flex flex-column flex-grow-1 text-ellipsis">
                                <span class="body-2 primary--text font-weight-bold">
                                    {{((filterShots(item.row.shots,'area',['outBoxDeepRight','outBoxDeepLeft','outBoxRight','outBoxCentreRight','outBoxCentre','outBoxCentreLeft','outBoxLeft','right35','centreRight35','centre35','centreLeft35','left35'],'').length / item.row.shots.length) * 100).toFixed(0).replace("NaN",0)}}%
                                </span>
                                <div class="d-flex align-center text-ellipsis">
                                    <span class="body-2 text-ellipsis primary--text">{{filterShots(item.row.shots,'area',['outBoxDeepRight','outBoxDeepLeft','outBoxRight','outBoxCentreRight','outBoxCentre','outBoxCentreLeft','outBoxLeft','right35','centreRight35','centre35','centreLeft35','left35'],'').length}} {{$t("game.stats.shots")}}</span>
                                </div>
                            </div>
                            <div class="d-flex flex-column align-center">
                                <v-badge inline color="black" text-color="white" :content="filterShots(item.row.shots,'area',['outBoxDeepRight','outBoxDeepLeft','outBoxRight','outBoxCentreRight','outBoxCentre','outBoxCentreLeft','outBoxLeft','right35','centreRight35','centre35','centreLeft35','left35'],'',true).length || '0'" class="font-weight-bold"></v-badge>
                                <span class="black--text mt-n1" style="font-size:10px;">{{$t("playerRecruitment.radarDescription.basicStatistics.goals")}}</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <!-- Areas Section End -->

                <!-- BodyPart Section Start -->
                <el-table-column v-if="type === 'bodyPart'" prop="bodyPart1" :label="$t('finishingMap.leftFooted')" label-class-name="primary--text" class-name="full-size-cell">
                    <template slot-scope="item">
                        <div class="w-100 h-100 d-flex align-start justify-space-between pl-2 pr-2 py-1"
                            v-bind:style="{'background-color':getBackgroundColorBlue(item.row,'bodyPart',['Left footed',''])}">
                            <div class="d-flex flex-column flex-grow-1 text-ellipsis">
                                <span class="body-2 primary--text font-weight-bold">
                                    {{((filterShots(item.row.shots,'bodyPart','Left footed','').length / item.row.shots.length) * 100).toFixed(0).replace("NaN",0)}}%
                                </span>
                                <div class="d-flex align-center text-ellipsis">
                                    <span class="body-2 text-ellipsis primary--text">{{filterShots(item.row.shots,'bodyPart','Left footed','').length}} {{$t("game.stats.shots")}}</span>
                                </div>
                            </div>
                            <div class="d-flex flex-column align-center">
                                <v-badge inline color="black" text-color="white" :content="filterShots(item.row.shots,'bodyPart','Left footed','',true).length || '0'" class="font-weight-bold"></v-badge>
                                <span class="black--text mt-n1" style="font-size:10px;">{{$t("playerRecruitment.radarDescription.basicStatistics.goals")}}</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column v-if="type === 'bodyPart'" prop="bodyPart2" :label="$t('finishingMap.rightFooted')" label-class-name="primary--text" class-name="full-size-cell">
                    <template slot-scope="item">
                        <div class="w-100 h-100 d-flex align-start justify-space-between pl-2 pr-2 py-1"
                            v-bind:style="{'background-color':getBackgroundColorBlue(item.row,'bodyPart',['Right footed',''])}">
                            <div class="d-flex flex-column flex-grow-1 text-ellipsis">
                                <span class="body-2 primary--text font-weight-bold">
                                    {{((filterShots(item.row.shots,'bodyPart','Right footed','').length / item.row.shots.length) * 100).toFixed(0).replace("NaN",0)}}%
                                </span>
                                <div class="d-flex align-center text-ellipsis">
                                    <span class="body-2 text-ellipsis primary--text">{{filterShots(item.row.shots,'bodyPart','Right footed','').length}} {{$t("game.stats.shots")}}</span>
                                </div>
                            </div>
                            <div class="d-flex flex-column align-center">
                                <v-badge inline color="black" text-color="white" :content="filterShots(item.row.shots,'bodyPart','Right footed','',true).length || '0'" class="font-weight-bold"></v-badge>
                                <span class="black--text mt-n1" style="font-size:10px;">{{$t("playerRecruitment.radarDescription.basicStatistics.goals")}}</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column v-if="type === 'bodyPart'" prop="bodyPart3" :label="$t('finishingMap.head')" label-class-name="primary--text" class-name="full-size-cell">
                    <template slot-scope="item">
                        <div class="w-100 h-100 d-flex align-start justify-space-between pl-2 pr-2 py-1"
                            v-bind:style="{'background-color':getBackgroundColorBlue(item.row,'bodyPart',['Head',''])}">
                            <div class="d-flex flex-column flex-grow-1 text-ellipsis">
                                <span class="body-2 primary--text font-weight-bold">
                                    {{((filterShots(item.row.shots,'bodyPart','Head','').length / item.row.shots.length) * 100).toFixed(0).replace("NaN",0)}}%
                                </span>
                                <div class="d-flex align-center text-ellipsis">
                                    <span class="body-2 text-ellipsis primary--text">{{filterShots(item.row.shots,'bodyPart','Head','').length}} {{$t("game.stats.shots")}}</span>
                                </div>
                            </div>
                            <div class="d-flex flex-column align-center">
                                <v-badge inline color="black" text-color="white" :content="filterShots(item.row.shots,'bodyPart','Head','',true).length || '0'" class="font-weight-bold"></v-badge>
                                <span class="black--text mt-n1" style="font-size:10px;">{{$t("playerRecruitment.radarDescription.basicStatistics.goals")}}</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column v-if="type === 'bodyPart'" prop="bodyPart4" :label="$t('finishingMap.otherBodyPart')" label-class-name="primary--text" class-name="full-size-cell">
                    <template slot-scope="item">
                        <div class="w-100 h-100 d-flex align-start justify-space-between pl-2 pr-2 py-1"
                            v-bind:style="{'background-color':getBackgroundColorBlue(item.row,'bodyPart',['Other body part',''])}">
                            <div class="d-flex flex-column flex-grow-1 text-ellipsis">
                                <span class="body-2 primary--text font-weight-bold">
                                    {{((filterShots(item.row.shots,'bodyPart','Other body part','').length / item.row.shots.length) * 100).toFixed(0).replace("NaN",0)}}%
                                </span>
                                <div class="d-flex align-center text-ellipsis">
                                    <span class="body-2 text-ellipsis primary--text">{{filterShots(item.row.shots,'bodyPart','Other body part','').length}} {{$t("game.stats.shots")}}</span>
                                </div>
                            </div>
                            <div class="d-flex flex-column align-center">
                                <v-badge inline color="black" text-color="white" :content="filterShots(item.row.shots,'bodyPart','Other body part','',true).length || '0'" class="font-weight-bold"></v-badge>
                                <span class="black--text mt-n1" style="font-size:10px;">{{$t("playerRecruitment.radarDescription.basicStatistics.goals")}}</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <!-- BodyPart Section End -->
            </el-table>
        </div>
    </div>
</template>

<script>

import {getLeagueAndYearName} from '../../utils/functions';

  export default {
    name: 'FinishingTable',
    components:{
    },
    computed:{
        currentUser() {
            return this.$store.state.auth.user;
        },
        currentUserLanguage() {
            return this.$store.getters["auth/language"];
        },
        currentUserFieldColor() {
            return this.$store.getters["auth/fieldColor"];
        },
        darkMode(){
            return this.currentUser.darkMode || this.$vuetify.theme.dark
        },
        rootElementId(){
            return `finishingTable${this.id}`
        },
        tableElementId(){
            return `finishingTable${this.id}Table`
        },
        shotsGrouped(){
            let base = _.chain(this.playerSeasonData).map((ps) => {
                ps.shots = _.filter(this.shots,(s) => s.seasonId === ps.seasonId && s.teamId === ps.teamId)
                return ps;
            }).orderBy("year","asc").value();
            base.push({
                seasonName: "Total",
                shots: this.shots
            })
            return base;
        },
        typeTitle(){
            if(this.type === 'xg'){
                return this.$t("statsNaming.xG")
            }
            if(this.type === 'typeShot'){
                return this.$t("finishingMap.typesOfShot")
            }
            if(this.type === 'shotStrategy'){
                return this.$t("finishingMap.shotStrategy")
            }
            if(this.type === 'area'){
                return this.$t("finishingMap.areas")
            }
            if(this.type === 'bodyPart'){
                return this.$t("finishingMap.bodyPart")
            }
        }
    },
    props: {
        id: {
            type: String,
            required: true
        },
        shots: {
            type: Array,
            required: false
        },
        type: {
            type: String,
            default: 'xg'
        },
        playerSeasonData:{
            type: Array,
            default: () => {
                return [];
            }
        },
        size:{
            type: Number,
            required: true
        }
    },
    created(){
    },
    async mounted(){
    },
    data() {
      return {
      }
    },
    watch: {
    },
    methods:{
        filterShots(shots,criteria,value1,value2,onlyGoals = false){
            return _.filter(shots,(s) => {
                let criteriaOK;
                if(criteria === 'xg'){
                   criteriaOK = s.xG >= value1 && s.xG < value2;
                }
                if(criteria === 'typeShot'){
                  if(value1 === "SAVED SHOT"){
                    //For SAVED SHOT remove shots blocked by a player
                    criteriaOK = s.type === value1 && !s.blockedByOutfielderPlayer;
                  }else{
                    criteriaOK = s.type === value1;
                  }
                }
                if(criteria === 'shotStrategy'){
                   criteriaOK = s.strategy === value1;
                }
                if(criteria === 'area'){
                   criteriaOK = this.shotInArea(s,value1);
                }
                if(criteria === 'bodyPart'){
                   criteriaOK = s.bodyPart === value1;
                }
                return criteriaOK && ((onlyGoals && s.type === 'GOAL') || !onlyGoals);
            })
        },
        getBackgroundColorBlue(row,criteria,values){
            if(row.seasonName != 'Total'){
                let max = _.chain(this.shotsGrouped).filter(d => d.seasonName !== 'Total').map((d) => this.filterShots(d.shots,criteria,values[0],values[1]).length).max();
                let min = _.chain(this.shotsGrouped).filter(d => d.seasonName !== 'Total').map((d) => this.filterShots(d.shots,criteria,values[0],values[1]).length).min();
                let data = this.filterShots(row.shots,criteria,values[0],values[1]).length;
                let percentageOfColor = (data - min) / (max - min);
                return `rgba(51, 102, 255,${percentageOfColor / 1.35})`;
            }else{
                return `white`
            }
        },
        shotInArea(s,areaModel) {
            return (areaModel.includes('goalArea') || !(s.x >= 94.2 && s.y >= 36.8 && s.y <= 63.2)) &&
                (areaModel.includes('boxRight') || !(s.x >= 83 && s.y >= 21.1 && s.y < 36.8)) &&
                (areaModel.includes('boxCenter') || !(s.x >= 83 && s.x < 94.2 && s.y >= 36.8 && s.y <= 63.2)) &&
                (areaModel.includes('boxLeft') || !(s.x >= 83 && s.y > 63.2 && s.y <= 78.9)) &&
                (areaModel.includes('outBoxDeepRight') || !(s.x >= 83 && s.y < 21.1)) &&
                (areaModel.includes('outBoxDeepLeft') || !(s.x >= 83 && s.y > 78.9)) &&
                (areaModel.includes('outBoxRight') || !(s.x >= 65 && s.x < 83 && s.y < 21.1)) &&
                (areaModel.includes('outBoxCentreRight') || !(s.x >= 65 && s.x < 83 && s.y >= 21.1 && s.y <= 35.5)) &&
                (areaModel.includes('outBoxCentre') || !(s.x >= 65 && s.x < 83 && s.y > 35.5 && s.y <= 64.4)) &&
                (areaModel.includes('outBoxCentreLeft') || !(s.x >= 65 && s.x < 83 && s.y > 64.4 && s.y <= 78.9)) &&
                (areaModel.includes('outBoxLeft') || !(s.x >= 65 && s.x < 83 && s.y > 78.9)) &&
                (areaModel.includes('right35') || !(s.x >= 50 && s.x < 65 && s.y < 21.1)) &&
                (areaModel.includes('centreRight35') || !(s.x >= 50 && s.x < 65 && s.y >= 21.1 && s.y <= 35.5)) &&
                (areaModel.includes('centre35') || !(s.x >= 50 && s.x < 65 && s.y > 35.5 && s.y <= 64.4)) &&
                (areaModel.includes('centreLeft35') || !(s.x >= 50 && s.x < 65 && s.y > 64.4 && s.y <= 78.9)) &&
                (areaModel.includes('left35') || !(s.x >= 50 && s.x < 65 && s.y > 78.9))
        },
        formatLeagueLabelYear(obj){
            return getLeagueAndYearName(obj,obj.year);
        }
    },
    destroyed(){
    }
  }
</script>

<style lang="scss">
.finishing-table{
  td.full-size-cell{
    height: 100%;
    padding: 0 !important;
    >.cell{
      height: 100% !important;
      padding: 0 !important;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  td.full-size-cell{
    &.left{
      .cell{
        justify-content: flex-start !important;
      }
    }
    &.right{
      .cell{
        justify-content: flex-end !important;
      }
    }
    &.center{
      .cell{
        justify-content: center !important;
      }
    }
  }
  .el-table__header {
        th {
            padding: 0;
            &.category-header{
                background-color: var(--v-primary-base) !important;
                font-weight: bold !important;
                >*{
                    color:white !important;
                }
            }
        }
        .is-group th{
            background: white;
        }
    }
    .cell.text-ellipsis{
        white-space: nowrap !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/base/FinishingTable.vue